import { toast } from 'react-toastify';
import { handleApiErrors } from '../../api/apiErrorHandler';
import { apiUrl } from '../../api/apiUrl';
import http from '../../api/axios';
import { paths } from '../../pages/RouterContainer';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../modal/modal';
import { useTranslation } from '../../context/translationContext';
import Button from '../button/Button';
import { useLoading } from '../../context/loadingContext';

interface Props {
  open: boolean;
  className?: string;
  onClose: () => void;
  documentId: string;
}

/**
 * Copy document dialog
 */
export const InvoiceCopy = ({ open, onClose, className, documentId }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { startLoading, stopLoading } = useLoading();

  /**
   * Creates a copy of selected document and redirects to new version
   * @param documentId of document
   */
  const handleCopyDocument = async (linkToOrigin: boolean) => {
    if (!documentId) return;
    try {
      startLoading();
      const response = await http.apiPost({
        url: `${apiUrl.ACCOUNTING_DOCUMENT_COPY}?documentId=${documentId}&linkToOrigin=${linkToOrigin}`,
      });
      if (response?.status === 201) {
        navigate(`/${paths.INVOICE}/${response.data.id}`);
        toast.success('Success!');
        stopLoading();
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <Modal
      open={open}
      title={t('page.invoice.copy-document-headline')}
      onClose={onClose}
      className={className}
    >
      <div className="mt-2">
        <p className="text-sm text-gray-500">{t('page.invoice.link-new-document')}</p>
      </div>

      <div className="mt-4">
        <Button
          type="button"
          onClick={() => handleCopyDocument(true)}
          title={t('general.yes')}
          className="mr-3"
          showLoading
        />
        <Button
          type="button"
          title={t('general.no')}
          onClick={() => handleCopyDocument(false)}
          showLoading
        />
      </div>
    </Modal>
  );
};
